const config = {
  name: "utah-state-fair",
  features: {
    accessCodes: true,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: false,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // The same day, just before 9am
    cancelDaysBefore: 0,
    cancelTime: "09:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 9 am
    startOffsetHrs: 9,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 300
  }
}
export default config
